/* SP Product Rail — flechas nav -> track.scrollBy (Regla 1/6).
   Idempotente y por-instancia (Regla 15): cada [data-sp-rail] es dueño de su track.
   Soporta varios rails en la misma página sin doble-binding. */
(function () {
  function initRail(rail) {
    if (!rail || rail.dataset.spRailBound === '1') return;
    rail.dataset.spRailBound = '1';

    var track = rail.querySelector('[data-sp-rail-track]');
    var prev = rail.querySelector('[data-sp-rail-prev]');
    var next = rail.querySelector('[data-sp-rail-next]');
    var nav = rail.querySelector('.sp-rail__nav');
    if (!track) return;

    function toggleNav() {
      // Ocultar controles cuando no hay overflow (menos ítems que columnas / no es carrusel)
      if (!nav) return;
      var overflow = track.scrollWidth - track.clientWidth > 2;
      nav.style.display = overflow ? '' : 'none';
    }

    function step() {
      var card = track.firstElementChild;
      if (!card) return Math.round(track.clientWidth * 0.8);
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '16') || 16;
      return card.getBoundingClientRect().width + gap;
    }
    function scroll(dir) {
      var max = track.scrollWidth - track.clientWidth;
      // bucle: al final + siguiente → principio; al principio + anterior → final
      if (dir > 0 && track.scrollLeft >= max - 2) { track.scrollTo({ left: 0, behavior: 'smooth' }); }
      else if (dir < 0 && track.scrollLeft <= 2) { track.scrollTo({ left: max, behavior: 'smooth' }); }
      else { track.scrollBy({ left: dir * step(), behavior: 'smooth' }); }
    }
    function syncArrows() {
      // flechas siempre activas (el carrusel hace bucle); solo se ocultan si no hay overflow (toggleNav)
      if (prev) prev.disabled = false;
      if (next) next.disabled = false;
    }
    if (prev) prev.addEventListener('click', function () { scroll(-1); });
    if (next) next.addEventListener('click', function () { scroll(1); });
    track.addEventListener('scroll', syncArrows, { passive: true });
    window.addEventListener('resize', function () { syncArrows(); toggleNav(); });
    syncArrows();
    toggleNav();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-sp-rail]').forEach(initRail);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  /* Editor: re-init al cargar sección (idempotente por dataset) */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
